export const initialState = {
  checkUserPending: false,
  checkUserError: null,
  email: null,
  username: null,
  jwt: null,
  checked: false,
};
